import EnquiryForm from './EnquiryForm';
import { createUser } from '../../util/test-data';

const author = createUser('janne', { profile: { displayName: 'Janne', abbreviatedName: 'JA' } });

export const Empty = {
  component: EnquiryForm,
  props: {
    formId: 'EnquiryFormExample',
    listingTitle: 'Sauna with a view',
    authorDisplayName: 'Janne',
    author,
    onSubmit(values) {
      console.log('submit with values:', values);
    },
  },
  group: 'forms',
};

// Enquiry composer with message attachments staged (see MessageAttachmentsPicker).
export const WithAttachments = {
  component: EnquiryForm,
  props: {
    formId: 'EnquiryFormWithAttachments',
    listingTitle: 'Sauna with a view',
    authorDisplayName: 'Janne',
    author,
    stagedAttachments: [
      {
        tempId: 'a',
        fileId: 'file-a',
        name: 'brief.pdf',
        size: 120000,
        progress: 100,
        state: 'available',
        error: null,
      },
      {
        tempId: 'b',
        fileId: null,
        name: 'reference-images.zip',
        size: 5000000,
        progress: 42,
        state: 'uploading',
        error: null,
      },
      {
        tempId: 'c',
        fileId: null,
        name: 'video.mov',
        size: 2000000000,
        progress: 0,
        state: 'failed',
        error: { type: 'error', name: 'Error', message: 'too large', status: 413 },
      },
    ],
    onUploadAttachment(file) {
      console.log('upload attachment:', file.name);
    },
    onRemoveAttachment(tempId) {
      console.log('remove attachment:', tempId);
    },
    onSubmit(values) {
      console.log('submit with values:', values);
    },
  },
  group: 'forms',
};
